
const crmHostList = ["localhost","piticommerce-merchant-admin.web.app","crm.pitiplus.app"]

export const availableCRM = () => {
    const host = window.location.hostname;
    return crmHostList.includes(host);
}